import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { ro } from './ro';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ro: { translation: ro } },
    fallbackLng: 'ro',
    supportedLngs: ['ro', 'en'],
    // Romanian is the default; only an explicit, remembered choice overrides it.
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'usc:lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
